import { render } from "./EmcAuth.vue?vue&type=template&id=826a7e54&scoped=true"
import script from "./EmcAuth.vue?vue&type=script&lang=js"
export * from "./EmcAuth.vue?vue&type=script&lang=js"

import "./EmcAuth.vue?vue&type=style&index=0&id=826a7e54&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-826a7e54"]])

export default __exports__